import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=2393c264&"
import script from "./SignForm.vue?vue&type=script&lang=js&"
export * from "./SignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports